import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from '@material-ui/core/ListItemText';
import withStyles from '@material-ui/core/styles/withStyles';
import commonStyles from "assets/jss/common/common";
import classNames from "classnames";
import Button from 'components/CustomButtons/Button';
import CustomDropdown from 'components/CustomDropdown/CustomDropdown.jsx';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box } from "@mui/material";
import { useIsAuthenticated } from "hooks/userHook";
import WebTranslateText from "Utils/Translation/WebTranslateText";

const styles = {
    ...commonStyles,
    topHeader: {
        backgroundColor: commonStyles.blackColor
    },
    tabs: {
        display: 'flex',
        alignItems: 'center'
    },
    links: {
        display: 'flex'
    },
    link: {
        paddingRight: 20,
        "& a": {
            color: 'white',
            fontWeight: 400
        },
        "& a:hover": {
            color: commonStyles.infoColor
        }
    },
    links_container: {
        justifyContent: 'flex-end'
    },
    imageDropdownButton: {
        padding: "0 10px",
    },
    profileImg: {
        height: '3rem',
        objectFit: "contain",
        paddingRight: '1rem',
        paddingLeft: '1rem',
        cursor: 'pointer'
    },
    darkBlue: {
        backgroundColor: commonStyles.blueDarkColor,
        transition: 'all 1s'
    },
    list: {
        width: 'max-content'
    },
    topHeaderButton: {
        margin: 0,
        borderRadius: 0,
        height: '4rem',
        "&:hover": { backgroundColor: commonStyles.successColor },
    }
};

function TopHeader(props) {
    const location = useLocation()
    const history = useHistory()
    const isAuthenticated = useIsAuthenticated()
    const [menuIndex, setMenuIndex] = useState(0)

    const { classes } = props
    const pathname = location.pathname
    useEffect(() => window.location.replace('https://app.actelligent-capital.com/'), [])

    useEffect(() => {
        getSubMenu()
    }, [location])

    const getSubMenu = () => {

        if (pathname === '/') {
            setMenuIndex('home')
            return
        }
        if (pathname === '/about-us') {
            setMenuIndex('about_us')
            return
        }
        if (pathname === '/services') {
            setMenuIndex('service')
            return
        }
        if (pathname === '/ai-investments') {
            setMenuIndex('ai_investments')
            return
        }
        if (pathname === '/ai-analytics') {
            setMenuIndex('ai_analytics')
            return
        }
        if (pathname === '/contact') {
            setMenuIndex('contact')
            return
        }
        setMenuIndex(-1)

    }

    const topHeaderClass = classNames({
        [classes.topHeader]: true,
        [classes.darkBlue]: menuIndex > -1
    })
    const onClicMenu = (menu) => {
        switch (menu) {
            case 'home':
                history.push('/')
                break;
            case 'about_us':
                history.push('/about-us')
                break;
            case 'service':
                history.push('/services')
                break;
            case 'ai_investments':
                history.push('/ai-investments')
                break;
            case 'ai_analytics':
                history.push('/ai-analytics')
                break;
            case 'contact':
                history.push('/contact')
                break;
                        
            default:
                setMenuIndex(menu)
        }
    }

    const services = menuIndex === 'service' || menuIndex === 'ai_investments' || menuIndex === 'ai_analytics'

    return <div className={topHeaderClass}>
        <Box display={'flex'}>
            <Box className={classes.tabs} flex={1}>
                <div style={{ backgroundColor: menuIndex === 'home' ? commonStyles.successColor : 'transparent' }}>
                    <Button simple color='white' onClick={() => onClicMenu('home')} className={classes.topHeaderButton}>
                        <WebTranslateText text={'Home'} part="General" />
                    </Button>
                </div>
                <div style={{ backgroundColor: menuIndex === 'about_us' ? commonStyles.successColor : 'transparent' }}>
                    <Button simple color='white' onClick={() => onClicMenu('about_us')} className={classes.topHeaderButton}>
                        <WebTranslateText text={'ABOUT US'} part="General" />
                    </Button>
                </div>
                <CustomDropdown
                        reference={
                            <div style={{ backgroundColor: services ? commonStyles.successColor : 'transparent' }}>
                                <Button simple color='white' onClick={() => onClicMenu('service')} className={classes.topHeaderButton}>
                                    <WebTranslateText text={'Services'} part="Services" /><KeyboardArrowDownIcon />
                                </Button>
                            </div>
                        }
                        content={
                            <List className={classes.list + " " + classes.mlAuto}>
                                <ListItem
                                    button
                                    className={classNames(
                                        classes.listItem
                                    )}
                                    onClick={() => onClicMenu('ai_investments')}
                                >
                                    <ListItemText primary={<WebTranslateText text={'AI Investments'} part="General" />} />
                                </ListItem>
                                <ListItem
                                    button
                                    className={classNames(
                                        classes.listItem
                                    )}
                                    onClick={() => onClicMenu('ai_analytics')}
                                >
                                    <ListItemText primary={<WebTranslateText text={'AI Analytics'} part="General" />} />
                                </ListItem>
                            </List>
                        }
                    />
                <div style={{ backgroundColor: menuIndex === 'contact' ? commonStyles.successColor : 'transparent' }}>
                    <Button simple color='white' onClick={() => onClicMenu('contact')} className={classes.topHeaderButton}>
                        <WebTranslateText text={'Contact'} part="General" />
                    </Button>
                </div>
            </Box>
            <Box className={classes.tabs + ' ' + classes.links_container}>
                    <Button
                        className={classes.navLink + " " + classes.topHeaderButton + " " + classes.loginBtn}
                        onClick={() => window.open('https://app.actelligent-capital.com/auth/login')}
                        simple
                    >
                        <WebTranslateText text={'Log In'} part="General" />
                    </Button>
                
                    <Button
                        className={classes.navLink + " " + classes.topHeaderButton + " " + classes.loginBtn}
                        onClick={() => window.open('https://app.actelligent-capital.com/auth/signup')}
                        simple
                    >
                        <WebTranslateText text={'Sign Up'} part="General" />
                    </Button>
            </Box>
        </Box>
    </div>;
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
    withStyles(styles, { withTheme: true })(TopHeader)
);